import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './action'
import getters from './getters'
import playList from './modules/playList'
import playerState from './modules/playerState'
import showOpenApp from './modules/showOpenApp'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        yzMembershipInfo: {
            user_data: {}
        },
        yzSubUrl: '',
        gxMembershipInfo: {
            user_data: {}
        },
        yzgxSubUrl: ''
    },
    modules: {
        playList,
        playerState,
        showOpenApp
    },
    getters,
    mutations: {
        SET_YZ_MEMBER_INFO(state, val) {
            state.yzMembershipInfo = val
        },
        SET_YZ_SUB_URL(state, val) {
            state.yzSubUrl = val
        },
        SET_GX_MEMBER_INFO(state, val) {
            state.gxMembershipInfo = val
        },
        SET_GX_SUB_URL(state, val) {
            state.yzgxSubUrl = val
        },
    }
})

export default store
